import { useState, useMemo } from 'react';
import { useGetTeamResultsByFormatMemberQuery } from '../state/api';
import FormatStatsPage from './format-stats-page';
import { transformFormatSummary, summarizeFormatsByPopularity } from './format-stats.utils';

const FormatStatsPageContainer = () => {
  const { data: formatSummary = [] } = useGetTeamResultsByFormatMemberQuery();

  const mapFormatSummary = useMemo(() => transformFormatSummary(formatSummary), [formatSummary]);

  // Summarize and sort formats by popularity
  const formatsPlayedSorted = useMemo(() => summarizeFormatsByPopularity(mapFormatSummary), [mapFormatSummary]);

  // State management for active tab
  const [activeFormat, setActiveFormat] = useState<string>(
    formatsPlayedSorted.length > 0 ? formatsPlayedSorted[0].formatName : ''
  );

  // Update active format when data changes (e.g., first load)
  useMemo(() => {
    if (formatsPlayedSorted.length > 0 && !activeFormat) {
      setActiveFormat(formatsPlayedSorted[0].formatName);
    }
  }, [formatsPlayedSorted, activeFormat]);

  return (
    <FormatStatsPage
      mapFormatSummary={mapFormatSummary}
      formatsPlayedSorted={formatsPlayedSorted}
      activeFormat={activeFormat}
      onFormatChange={setActiveFormat}
    />
  );
};

export default FormatStatsPageContainer;
